import React, {useState, useEffect} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {InputNumber} from "primereact/inputnumber";
import {Button} from 'primereact/button';
import {Dropdown} from "primereact/dropdown";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputMask} from "primereact/inputmask";
import {Calendar} from "primereact/calendar";
import {ConfirmDialog} from "primereact/confirmdialog";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import FormLocker from "../../util/FormLocker";
import moment from "moment";
import currencyFormatter from "currency-formatter";
import {Message} from "primereact/message";

const _FM_ServiceFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({
    currency: 'EUR'
  });
  const [newFormData, setNewFormData] = useState({});
  const [accommodations, setAccommodations] = useState([]);
  const [units, setUnits] = useState([]);
  const [vatGroups, setVatGroups] = useState([]);
  const [serviceFors, setServiceFors] = useState([]);
  const [CFormData, setCFormData] = useState({});
  const [COptions, setCOptions] = useState({});
  const [CFields, setCFields] = useState([]);
  const [TFormData, setTFormData] = useState({});
  const [TFormDialog, setTFormDialog] = useState(false);
  const [TOptions, setTOptions] = useState({});
  const [TFields, setTFields] = useState([]);
  const [TTasks, setTTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  const validate = (data) => {
    let errors = {};
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (formData && formData.id) {
      axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service/" + formData.id,
        newFormData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data);
          setNewFormData({});
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderServiceList: true,
            selectedServiceId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    } else {
      axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service",
        formData,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
        .then(response => {
          setFormData(response.data.data)
          setLoading(false)
          window.App.toastShow('success', t('success'), response.data.message)
          window.App.setState({
            rerenderServiceList: true,
            selectedServiceId: response.data.data.id
          })
          if (props.closeForm === true) {
            navigate(-1)
          }
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "timed-task?&search[entity_id][operator]=%3D&search[entity_id][value]=" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTTasks(response.data.data.items);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "info/timed-task/ServicePriceChange",
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          response.data.editable_fields.map(field => {
            if (field.name === "entity_id") {
              setTFormData({
                ...TFormData,
                entity_id: id
              })
            }
          })
          setTFields(response.data.editable_fields);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/service-unit",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setUnits(response.data.data);
      })
      .catch(error => {

      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/service-for",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setServiceFors(response.data.data);
      })
      .catch(error => {

      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setAccommodations(response.data.data.items);
        // if(response.data.data.items && response.data.data.items[0]) {
        //   setFormData({
        //     ...formData,
        //     currency: response.data.data.items[0].currency_code
        //   })
        // }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "vat-group",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        setVatGroups(response.data.data.items);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [window.App.state.rerenderServiceForm])

  useEffect(() => {
    setCFormData({
      ...CFormData,
      service: formData.id
    })
  }, [formData.id])

  useEffect(() => {
    if (formData._country_specifics && Object.keys(formData._country_specifics).length > 0) {
      let countryObjectName = "service_" + Object.keys(formData._country_specifics)[0].toLowerCase() + "s";
      if (formData[countryObjectName][0]) {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-"
            + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + formData[countryObjectName][0].id,
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            setCFormData(response.data.data);
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      }
      const transformedCountry = Object.keys(formData._country_specifics)[0]
        ? Object.keys(formData._country_specifics)[0].charAt(0).toUpperCase() + Object.keys(formData._country_specifics)[0].slice(1).toLowerCase() : "";
      if (Object.keys(formData._country_specifics)[0].toLowerCase() == formData?.accommodation?.country?.toLowerCase()) {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "info/Service" + transformedCountry,
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            setCFields(response.data.editable_fields);
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      }
    }
  }, [formData._country_specifics])

  useEffect(() => {
    CFields.map((field, index) => {
      if (field.type.includes("Enum")) {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/" + field.name.replaceAll('_', '-'),
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            setCOptions({
              ...COptions,
              [field.name]: Object.values(response.data.data).flat()
            })
          })
          .catch(error => {

          })
      }
    })
  }, [CFields])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i
        className="pi pi-exclamation-triangle blocked-ui-message-icon"
        aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <Form onSubmit={onSubmit} initialValues={formData}
              validate={validate} render={({handleSubmit}) => (
          <form onSubmit={handleSubmit} className="">
            <Panel className={"p-mt-3"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center"}>
                  <h2 className={"p-m-0"}>{t('service_form')}</h2>
                </div>
                <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
                  <Button type="submit" aria-label={t('save')} icon={"pi pi-save"}
                          loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                  {formData.id &&
                    <Button type="submit" aria-label={t('save_and_close')}
                            loading={loading}
                            onClick={() => {
                              props = {...props, closeForm: true}
                            }}
                            className="p-button-success p-ml-2">
                      <span>
                        <i className={"pi pi-save"}></i>&nbsp;&nbsp;<i className={"pi pi-backward"}></i>
                      </span>
                    </Button>
                  }
                  <Button type="button"
                          icon={"pi pi-times"}
                          onClick={() => {
                            navigate(-1)
                          }}
                          className="p-button-secondary close p-ml-2">
                  </Button>
                </div>
              </div>
              {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
              <HelpComponent type={"edit_box"}/>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"name"}/>
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('name')}</label>
                      <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className="p-col-12 p-lg-4">
                  <Field name="currency" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="currency"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>
                        {t('accommodation')}
                      </label>
                      <span className="p-d-block">
                            <Dropdown  options={accommodations}
                                      optionLabel="name"
                                      optionValue="id"
                                      id={"accommodation"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        let _accommodation = accommodations.filter(accommodation => accommodation.id === e.value)[0];
                                        setFormData({
                                          ...formData,
                                          accommodation: e.value,
                                          currency: _accommodation.currency_code,
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          accommodation: e.value,
                                          currency: _accommodation.currency_code,
                                        })
                                      }}
                                      value={formData?.accommodation?.id || formData.accommodation}
                            />
                          </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-4"}>
                  <Field name="available_for" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"available_for"}/>
                      <label htmlFor="available_for"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('available_for')}</label>
                      <span className="p-d-block">
                          <Dropdown  options={serviceFors}
                                    filter
                                    optionLabel={(option) => window.App.getTranslatedLabel(option.value)}
                                    optionValue="value"
                                    id={"available_for"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        available_for: e.value
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        available_for: e.value
                                      })
                                    }}
                                    value={formData?.available_for?.id || formData.available_for}
                          />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3 p-xl-3"}>
                  <Field name="net_amount" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"net_amount"}/>
                      <label htmlFor="net_amount"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('net_amount')}</label>
                      <span className="p-d-block">
                      <InputText id="net_amount" {...input}
                                 keyfilter={"num"}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     net_amount: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     net_amount: e.target.value
                                   })
                                 }}
                                 value={formData.net_amount}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className={"p-col-12 p-lg-3 p-xl-3"}>
                  <Field name="currency" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"currency"}/>
                      <label htmlFor="currency"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('currency')}</label>
                      <span className="p-d-block fake-input">
                        {formData.currency}
                      </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                <div className="p-col-12 p-lg-3">
                  <Field name="vat_group" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="vat_group"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>
                        {t('vatgroup')}
                      </label>
                      <span className="p-d-block">
                            <Dropdown  options={vatGroups}
                                      optionLabel="name"
                                      optionValue="id"
                                      id={"vat_group"}
                                      emptyMessage={t('empty_message')}
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          vat_group: e.value,
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          vat_group: e.value,
                                        })
                                      }}
                                      value={formData?.vat_group?.id || formData.vat_group}
                            />
                          </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {/*<div className={"p-col-12 p-lg-3 p-xl-3"}>*/}
                {/*  <Field name="vat_percent" render={({input, meta}) => (*/}
                {/*    <div className="p-field p-fluid">*/}
                {/*      <HelpComponent type={"field"} field={"vat_percent"}/>*/}
                {/*      <label htmlFor="vat_percent"*/}
                {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('vat_percent')}</label>*/}
                {/*      <span className="p-d-block">*/}
                {/*      <InputText id="vat_percent" {...input}*/}
                {/*                   onChange={(e) => {*/}
                {/*                     setFormData({*/}
                {/*                       ...formData,*/}
                {/*                       vat_percent: e.value*/}
                {/*                     })*/}
                {/*                     setNewFormData({*/}
                {/*                       ...newFormData,*/}
                {/*                       vat_percent: e.value*/}
                {/*                     })*/}
                {/*                   }}*/}
                {/*                   disabled={formData.editable === false}*/}
                {/*                   value={formData.vat_percent}*/}
                {/*                   className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
                {/*    </span>*/}
                {/*      {getFormErrorMessage(meta)}*/}
                {/*    </div>*/}
                {/*  )}/>*/}
                {/*</div>*/}
                <div className={"p-col-12 p-lg-3 p-xl-3"}>
                  <Field name="unit" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <HelpComponent type={"field"} field={"unit"}/>
                      <label htmlFor="unit"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>{t('unit')}</label>
                      <span className="p-d-block">
                          <Dropdown  options={units}
                                    filter
                                    optionLabel="label"
                                    optionValue="value"
                                    id={"unit"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        unit: e.value
                                      })
                                      setNewFormData({
                                        ...newFormData,
                                        unit: e.value
                                      })
                                    }}
                                    value={formData?.unit?.id || formData.unit}
                          />
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
              </div>
            </Panel>
          </form>
        )}/>
        <BlockUI blocked={!formData.id} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i
          className="pi pi-exclamation-triangle blocked-ui-message-icon"
          aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0"}>
              {CFields && CFields[0] ? (
                <>
                  {Object.keys(formData._country_specifics)[0].toUpperCase()}
                </>
              ) : (
                <>
                  {t('country_specific_settings')}
                </>
              )}
            </h3>
            <div className={"p-grid"}>
              {CFields && CFields[0] ? (
                <>
                  {CFields.map((field, index) => {
                    if (field.type.includes("Text")) {
                      return (
                        <>
                          <div className={"p-col-12 p-lg-6"}>
                            <div className="p-field p-fluid">
                              <label htmlFor={field.name}>{t(field.name)}</label>
                              <span className="p-d-block">
                                      <InputText id={field.name}
                                                 disabled={!formData.id || formData.editable === false}
                                                 onChange={(e) => {
                                                   setCFormData({
                                                     ...CFormData,
                                                     [field.name]: e.target.value
                                                   })
                                                 }}
                                                 value={CFormData[field.name]}
                                      />
                                    </span>
                            </div>
                          </div>
                        </>
                      )
                    }
                    if (field.type.includes("Enum")) {
                      return (
                        <>
                          <div className={"p-col-12 p-lg-6"}>
                            <div className="p-field p-fluid">
                              <label htmlFor={field.name}>{t(field.name)}</label>
                              <span className="p-d-block">
                                      <Dropdown  options={COptions[field.name]}
                                                filter
                                                optionLabel={(option) => window.App.getTranslatedLabel(option.value)}
                                                optionValue="key"
                                                id={field.name}
                                                disabled={formData.editable === false}
                                                emptyMessage={t('empty_message')}
                                                onChange={(e) => {
                                                  setCFormData({
                                                    ...CFormData,
                                                    [field.name]: e.value
                                                  })
                                                }}
                                                value={CFormData[field.name]}
                                      />
                                    </span>
                            </div>
                          </div>
                        </>
                      )
                    }
                  })}
                </>
              ) : (
                <div className={"p-col"}>
                  <p>{t('country_specific_settings_after_save')}</p>
                </div>
              )}
            </div>
            <div className={"p-grid"}>
              <div className={"p-col p-text-right p-col-align-center"}>
                <Button type="button" label={t('save')} icon={"pi pi-save"}
                        loading={loading}
                        disabled={!formData.id}
                        onClick={() => {
                          setLoading(true)
                          if (CFormData.id) {
                            axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-"
                              + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + CFormData.id,
                              CFormData,
                              {
                                params: {},
                                headers: {
                                  'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                  "Sys-name": Cookies.get("instanceId"),
                                  "Preferred-locale": Cookies.get("language")
                                }
                              })
                              .then(response => {
                                setCFormData(response.data.data);
                                setLoading(false)
                                window.App.toastShow('success', t('success'), response.data.message)
                              })
                              .catch(error => {
                                setLoading(false)
                                window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                              })
                          } else {
                            axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "service-" + Object.keys(formData._country_specifics)[0].toLowerCase(),
                              CFormData,
                              {
                                params: {},
                                headers: {
                                  'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                  "Sys-name": Cookies.get("instanceId"),
                                  "Preferred-locale": Cookies.get("language")
                                }
                              })
                              .then(response => {
                                setCFormData(response.data.data);
                                setLoading(false)
                                window.App.toastShow('success', t('success'), response.data.message)
                              })
                              .catch(error => {
                                setLoading(false)
                                window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                              })
                          }

                        }}
                        className="p-button-success p-ml-2"/>
              </div>
            </div>
          </Panel>
        </BlockUI>
        {TFields && TFields[0] &&
          <Panel className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-4 p-col-align-center"}>
                <h3 className={"p-m-0"}>{t('timed_price_change_tasks')}</h3>
              </div>
              <div className={"p-col p-text-right p-col-align-center"}>
                <Button type="button" label={t('new_timed_price_change_task')} icon={"pi pi-plus"}
                        onClick={() => {
                          setTFormData({
                            entity_id: id
                          })
                          setTFormDialog(true)
                        }}
                        className="p-button-success p-ml-2"/>
              </div>
            </div>
            <DataTable
              value={TTasks}
              size={"small"}
              loading={loading} lazy
              emptyMessage={t('empty_message')}
              autoLayout={true}
              responsiveLayout={window.App.state.responsiveLayout}
              breakpoint="1365px"
              stripedRows
              dataKey="id"
              selectionMode={"single"}
            >

              <Column field="net_amount" sortable header={t('net_amount')}
                      className={"p-text-right"}
                      body={(rowData) => {
                        return (
                          <>
                            {currencyFormatter.format(
                              rowData.net_amount, {
                                precision: t('currency_precision'),
                                symbol: t('currency_symbol'),
                                decimal: t('currency_decimal'),
                                thousand: t('currency_thousand'),
                              }
                            )}
                            &nbsp;{formData?.currency}
                          </>
                        )
                      }}></Column>
              <Column field="execute_at" sortable header={t('execute_at')}
                      body={(rowData) => {
                        if (rowData.execute_at !== null) {
                          return (
                            <span>{moment.utc(rowData.execute_at).format(t('YYYY-MM-DD HH:mm'))}</span>
                          )
                        }
                      }}
              ></Column>
              <Column field="created_at_snapshot" sortable header={t('created_at')}
                      body={(rowData) => {
                        if (rowData.created_at_snapshot !== null) {
                          return (
                            <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                          )
                        }
                      }}></Column>
              <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                      filterField={"updated_at"}
                      sortField={"updated_at"}
                      body={(rowData) => {
                        if (rowData.updated_at_snapshot !== null) {
                          return (
                            <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                          )
                        }
                      }}></Column>
              <Column className={"p-text-right p-text-nowrap"}
                      body={(rowData) => {
                        return (
                          <>
                            <Button icon="pi pi-pencil" className="p-button-sm  p-button-warning p-mr-2"
                                    tooltip={t('edit')}
                                    tooltipOptions={{position: 'left'}}
                                    onClick={() => {
                                      setTFormData(rowData)
                                      setTFormDialog(true)
                                    }}/>
                            <Button icon="pi pi-trash" className="p-button-sm  p-button-danger"
                                    tooltip={t('delete')}
                                    tooltipOptions={{position: 'left'}}
                                    onClick={() => {
                                      window.App.setState({[`confirmDelete${rowData.id}`]: true})
                                    }}
                            />
                            <ConfirmDialog group="declarative" visible={window.App.state[`confirmDelete${rowData.id}`]}
                                           acceptLabel={t('yes')} rejectLabel={t('no')}
                                           onHide={() => {
                                             window.App.setState({[`confirmDelete${rowData.id}`]: false})
                                           }}
                                           message={t('confirm_delete')} header={t('confirm_delete')}
                                           icon="pi pi-exclamation-triangle"
                                           accept={() => {
                                             window.App.delete('timed-task', rowData.id)
                                               .then(response => {
                                                 window.App.toastShow('success', t('success_delete'),);
                                                 window.App.setState({rerenderServiceForm: Math.random()})
                                               })
                                               .catch(error => {
                                                 window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                               })
                                           }}
                                           reject={() => {
                                             window.App.setState({[`confirmDelete${rowData.id}`]: false})
                                           }}/>
                          </>
                        )
                      }}>

              </Column>
            </DataTable>
            <Dialog header={t('timed_price_change_task')} visible={TFormDialog}
                    footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}}
                                                     severity="info" text={t("dialog_movable")}/></React.Fragment>}
                    onHide={() => {
                      setTFormDialog(false)
                    }} modal={false}>
              <Panel className={"pm-t-3"}>
                <div className={"p-grid"}>
                  {TFields && TFields[0] &&
                    <>
                      {TFields.map((field, index) => {
                        if (field.type.includes("Text") && field.name !== "entity_id") {
                          return (
                            <>
                              <div className={"p-col-12 p-lg-6"}>
                                <div className="p-field p-fluid">
                                  <label htmlFor={field.name}>{t(field.name)}</label>
                                  <span className="p-d-block">
                                      <InputText id={field.name}
                                                 disabled={!formData.id || formData.editable === false}
                                                 onChange={(e) => {
                                                   setTFormData({
                                                     ...TFormData,
                                                     [field.name]: e.target.value
                                                   })
                                                 }}
                                                 value={TFormData[field.name]}
                                      />
                                    </span>
                                </div>
                              </div>
                            </>
                          )
                        }
                        if (field.type.includes("Number")) {
                          return (
                            <>
                              <div className={"p-col-12 p-lg-6"}>
                                <div className="p-field p-fluid">
                                  <label htmlFor={field.name}>{t(field.name)}</label>
                                  <span className="p-d-block">
                                      <InputText id={field.name}
                                                 keyfilter={"num"}
                                                 disabled={!formData.id || formData.editable === false}
                                                 onChange={(e) => {
                                                   setTFormData({
                                                     ...TFormData,
                                                     [field.name]: e.target.value
                                                   })
                                                 }}
                                                 value={TFormData[field.name]}
                                      />
                                    </span>
                                </div>
                              </div>
                            </>
                          )
                        }
                        if (field.type.includes("Date")) {
                          return (
                            <>
                              <div className={"p-col-12 p-lg-6"}>
                                <div className="p-field p-fluid">
                                  <label htmlFor={field.name}>{t(field.name)}</label>
                                  <div className="p-inputgroup calendar-icon-only">
                                    <InputMask id={"reserved_to"}
                                               mask={t('9999-99-99 99:99')}
                                               value={TFormData[field.name]}
                                               onChange={(e) => {
                                                 if (e.value.indexOf("_") === -1) {
                                                   if (e.value === '') {
                                                     e.value = null
                                                   }
                                                   setTFormData({
                                                     ...TFormData,
                                                     [field.name]: e.value
                                                   })
                                                 }
                                               }}
                                    />
                                    <Calendar
                                      value={TFormData[field.name] ? moment(TFormData[field.name]).toDate() : null}
                                      locale="default"
                                      dateFormat={t('YY-MM-DD')}
                                      showIcon
                                      showTime
                                      onChange={(e) => {
                                        setTFormData({
                                          ...TFormData,
                                          [field.name]: moment.utc(e.value).local().format(t('YYYY-MM-DD HH:mm'))
                                        })
                                      }}/>
                                  </div>
                                </div>
                              </div>
                            </>
                          )
                        }
                        if (field.type.includes("Enum")) {
                          return (
                            <>
                              <div className={"p-col-12 p-lg-6"}>
                                <div className="p-field p-fluid">
                                  <label htmlFor={field.name}>{t(field.name)}</label>
                                  <span className="p-d-block">
                                      <Dropdown  options={TOptions[field.name]}
                                                filter
                                                optionLabel={(option) => window.App.getTranslatedLabel(option.value)}
                                                optionValue="key"
                                                id={field.name}
                                                disabled={formData.editable === false}
                                                emptyMessage={t('empty_message')}
                                                onChange={(e) => {
                                                  setTFormData({
                                                    ...TFormData,
                                                    [field.name]: e.value
                                                  })
                                                }}
                                                value={TFormData[field.name]}
                                      />
                                    </span>
                                </div>
                              </div>
                            </>
                          )
                        }
                      })}
                    </>
                  }
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col p-text-right p-col-align-center"}>
                    <Button type="button" label={t('save')} icon={"pi pi-save"}
                            loading={loading}
                            disabled={!formData.id}
                            onClick={() => {
                              setLoading(true)
                              if (TFormData && TFormData.id) {
                                axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "timed-task/" + TFormData.id,
                                  TFormData,
                                  {
                                    params: {},
                                    headers: {
                                      'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                      "Sys-name": Cookies.get("instanceId"),
                                      "Preferred-locale": Cookies.get("language")
                                    }
                                  })
                                  .then(response => {
                                    setTFormData(response.data.data);
                                    setTFormDialog(false);
                                    setLoading(false)
                                    window.App.setState({rerenderServiceForm: Math.random()})
                                    window.App.toastShow('success', t('success'), response.data.message)
                                  })
                                  .catch(error => {
                                    setLoading(false)
                                    window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                  })
                              } else {
                                axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "timed-task/new/service_price_change",
                                  TFormData,
                                  {
                                    params: {},
                                    headers: {
                                      'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                      "Sys-name": Cookies.get("instanceId"),
                                      "Preferred-locale": Cookies.get("language")
                                    }
                                  })
                                  .then(response => {
                                    setTFormData(response.data.data);
                                    setTFormDialog(false);
                                    setLoading(false)
                                    window.App.setState({rerenderServiceForm: Math.random()})
                                    window.App.toastShow('success', t('success'), response.data.message)
                                  })
                                  .catch(error => {
                                    setLoading(false)
                                    window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                                  })
                              }
                            }}
                            className="p-button-success p-ml-2"/>
                  </div>
                </div>
              </Panel>
            </Dialog>
          </Panel>
        }
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_ServiceFormComponent);
